import { Box, CircularProgress, Typography } from "@mui/material";
import { ButtonCust, Divider, SimpleModal } from "../../widgets";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./CustomDateCalendar.scss";

const CustomDateCalendar = (props: any) => {
  const { isDivider, titleStyle, descStyle } = props;
  return (
    <SimpleModal
      isShowModal={props.isCalanderModal}
      onCloseModal={() => props.onCloseModal(false)}
      showClose={true}
      sx={{ top: "20px", borderRadius: "6px", width: "60%" }}
    >
      <Box className="container">
        <Typography className="cal_title" sx={titleStyle}>
          {props.title}
        </Typography>
        {isDivider && <Divider />}
        <Typography className="desc" sx={{...descStyle, paddingBottom: '7px'}}>
          {props.desc}
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            disablePast
            showDaysOutsideCurrentMonth
            onChange={props.onChange}
            className="dateCalendar"
            sx={{
              "& .MuiPickersDay-root": {
                "&.Mui-selected": {
                  backgroundColor: "var(--primary_color)!important",
                },
              },
              "& .MuiPickersYear-yearButton": {
                "&.Mui-selected": {
                  backgroundColor: "var(--primary_color)",
                },
              },
            }}
          />
        </LocalizationProvider>
        <ButtonCust variantType={props.variant} onClick={props.onClick} sx={{width: '250px'}}>
          {props.rescheduleFuturePackPending ? (
            <CircularProgress />
          ) : (
            props.button
          )}
        </ButtonCust>
      </Box>
    </SimpleModal>
  );
};

export default CustomDateCalendar;
